export default function DashboardCard({ title, value, warning }) {
  return (
    <div className={`card ${warning ? "warning" : ""}`}>
      <p className="card-title">{title}</p>
      <h2 className="card-value">{value}</h2>
    </div>
  );
}
